import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import { FieldError } from "react-hook-form";
import InputMask from "@mona-health/react-input-mask";
import Input from "../Input";

type DatesInputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: ReactNode;
  error?: FieldError;
};

const DatesInput = forwardRef<HTMLInputElement, DatesInputProps>(
  ({ value, onChange, placeholder, error, label, ...rest }, ref) => {
    return (
      <div
        className={`relative flex flex-col`}
        key={`DATE-${rest.defaultValue}`}
      >
        <InputMask
          ref={ref}
          mask={"99/99/9999"}
          type="text"
          value={value}
          onChange={onChange}
          placeholder={placeholder ?? "mm/dd/yyyy"}
          {...rest}
        >
          <Input error={error} label={label} />
        </InputMask>
      </div>
    );
  }
);

DatesInput.displayName = "DatesInput";

export default DatesInput;
